import { notify } from 'notiwind'

export function handleError(error, display = null, context = '') {
  error = error.error || error

  console.group(`🚨 Erreur gérée: ${context}`)
  console.error('Erreur complète:', error)
  console.error('Message:', error.message)
  console.error('Stack trace:', error.stack)
  console.error('Contexte:', context)
  console.error('Timestamp:', new Date().toISOString())
  console.error('URL:', window?.location?.href)
  console.error('User Agent:', window?.navigator?.userAgent)
  console.trace('Stack trace appelant:')
  console.groupEnd()

  const config = useRuntimeConfig()
  if (config.public.sentry.dsn) {
    const { $sentryCaptureException } = useNuxtApp()
    $sentryCaptureException(error)
  } else {
    console.error('Sentry non configuré - erreur non envoyée')
  }

  if (display) {
    notify({
      group: 'main',
      type: 'danger',
      title: 'Une erreur s’est produite',
      text: display.length ? display : 'Si le problème persiste, merci de contacter notre équipe'
    })
  }
}
